module.exports = __webpack_public_path__ + "f50240985898ceb205c461559d3cccee.png";